// extracted by mini-css-extract-plugin
export default {"ImgContainer":"BikeList_ImgContainer__pTJJh","PlaceholderImg":"BikeList_PlaceholderImg__3nhAz","List":"BikeList_List__vVNyO"};